__turbopack_context__.v({
  "fade-in": "FooterLinkGroup-module-scss-module__DpKgOq__fade-in",
  "header": "FooterLinkGroup-module-scss-module__DpKgOq__header",
  "headerIcon": "FooterLinkGroup-module-scss-module__DpKgOq__headerIcon",
  "headline": "FooterLinkGroup-module-scss-module__DpKgOq__headline",
  "list": "FooterLinkGroup-module-scss-module__DpKgOq__list",
  "listInner": "FooterLinkGroup-module-scss-module__DpKgOq__listInner",
  "listItem": "FooterLinkGroup-module-scss-module__DpKgOq__listItem",
  "root": "FooterLinkGroup-module-scss-module__DpKgOq__root",
});
